<!-- <div *ngIf="wait" class="d-flex flex-column justify-content-center align-items-center h-100">
    <div class="spinner-border text-danger"></div>
</div> -->
<div>
    <div id="test-container"></div>
    <h2 *ngIf="title" class="text-center my-3">{{title | translate}}</h2>
    <p *ngIf="subtitle" class="text-center mb-0" [innerHTML]="subtitle | translate"></p>

    <form *ngIf="form" [formGroup]="form">
        <div id="otp" class="otp-group row justify-content-between mx-auto mt-4 pt-3">
            <div class="form-group otp-field" [class.disabled]="waitOtp">
                <input #formRow1 id="formRow1" type="text" formControlName="input1" name="inputName1"
                    autocomplete="off" [value]="req.input1" class="form-control text-uppercase text-center" [class.border-success]="req?.input1"
                    (keyup)="keyUpEvent($event, 1)" (paste)="onPaste($event)" (click)="selectionEnd($event)">
            </div>
            <div class="form-group otp-field" [class.disabled]="waitOtp">
                <input #formRow2 id="formRow2" type="text" formControlName="input2" name="inputName2"
                    autocomplete="off" [value]="req.input2" class="form-control text-uppercase text-center" [class.border-success]="req?.input2"
                    (keyup)="keyUpEvent($event, 2)" (paste)="onPaste($event)" (click)="selectionEnd($event)">
            </div>
            <div class="form-group otp-field" [class.disabled]="waitOtp">
                <input #formRow3 id="formRow3" type="text" formControlName="input3" name="inputName3"
                    autocomplete="off" [value]="req.input3" class="form-control text-uppercase text-center" [class.border-success]="req?.input3"
                    (keyup)="keyUpEvent($event, 3)" (paste)="onPaste($event)" (click)="selectionEnd($event)">
            </div>
            <div class="form-group otp-field" [class.disabled]="waitOtp">
                <input #formRow4 id="formRow4" type="text" formControlName="input4" name="inputName4"
                    autocomplete="off" [value]="req.input4" class="form-control text-uppercase text-center" [class.border-success]="req?.input4"
                    (keyup)="keyUpEvent($event, 4)"  (paste)="onPaste($event)" (click)="selectionEnd($event)">
            </div>
            <div class="form-group otp-field" [class.disabled]="waitOtp">
                <input #formRow5 id="formRow5" type="text" formControlName="input5" name="inputName5"
                    autocomplete="off" [value]="req.input5" class="form-control text-uppercase text-center" [class.border-success]="req?.input5"
                    (keyup)="keyUpEvent($event, 5)"  (paste)="onPaste($event)" (click)="selectionEnd($event)">
            </div>
            <div class="form-group otp-field" [class.disabled]="waitOtp">
                <input #formRow6 id="formRow6" type="text" formControlName="input6" name="inputName6"
                    autocomplete="off" [value]="req.input6" class="form-control text-uppercase text-center" [class.border-success]="req?.input6"
                    (keyup)="keyUpEvent($event, 6)" (paste)="onPaste($event)" (click)="selectionEnd($event)">
            </div>
        </div>
        <!-- <div class="new-otp-group">
            <input 
            type="text" autocomplete="one-time-code" inputmode="numeric" pattern="\d{1}" maxlength="6" 
            formControlName="newOtpInput" class="input-otp-custom">
        </div> -->
    </form>
    <ng-container *ngIf="isError && counter">
        <div class="error text-center pt-2"><strong>{{"phone-validation-error" | translate }}</strong></div>
    </ng-container>
    <ng-container *ngIf="!counter">
        <div class="error text-center pt-2"><strong>{{"otp-time-expired-error" | translate }}</strong></div>
    </ng-container>

    <strong>
        <p *ngIf="!waitCounter && counter && counter !== '0' && counter !== ''" class="mt-5 mb-3 text-center">
            <span>{{"phone-validation-expire-time" | translate}} {{counter}}</span>
        </p>
    </strong>

    <div class="w-100 d-flex justify-content-center">
        <button class="my-3 text-center btn btn-tertiary" (click)="sendNewOtp()" [disabled]="waitOtp">
            {{"phone-validation-button-send-new" | translate}}</button>
    </div>
</div>